module.exports = __webpack_public_path__ + "image/about_img1.jpg";